import { MHTTPCL, JSON_STRING, HttpClient } from "../../../../services/http/http-client";
//import {HttpLib} from "../../../services/http/http-lib"
import { BOOKING_URL } from "../../../../services/common-urls";

export const BookingToursService = {
  getToursData: () => MHTTPCL.get(BOOKING_URL, {
    section: 'tourmgmt',
  
    output: JSON_STRING,
  }),
    
 

}